import PropTypes from "prop-types";
import ImageHelper from '../../../../../../../../utilities/helpers/ImageHelper';
import logo from '../../../../../../../../assets/images/experience_balnk.svg';
import { useDictionary } from "../../../../../../../../utilities/hooks/UseDictionary";
import {URI_GOOGLE_MAPS_PLACE_ID} from "../../../../../../../../config";

const ExperiencePoiItem = ({pointOfInterest, onItemCLicked}) => {
    const dictionary = useDictionary();


    return (
        <tr
			className="slot-booking-container"
			key={pointOfInterest.id}
			onClick={() => onItemCLicked(pointOfInterest)}
		>
            <td>
                <div className="booking-number">
                    {pointOfInterest.name ?? pointOfInterest.search_input}
                </div>
            </td>
            {/*<td>*/}
            {/*    <div className="d-flex-center custom-experience-container">*/}
            {/*        <div className="custom-experience-image-container">*/}
            {/*            <img*/}
            {/*                onError={(e) => {*/}
            {/*                    e.currentTarget.src = logo;*/}
            {/*                }}*/}
            {/*                src={pointOfInterest?.thumbnail_url ? ImageHelper.getFullImageUrl(pointOfInterest?.thumbnail_url) : logo}*/}
            {/*                className="custom-experience-image"*/}
            {/*            />*/}
            {/*        </div>*/}
            {/*        <div className="custom-experience-title truncate" title={pointOfInterest?.title}>*/}
            {/*            {pointOfInterest?.title}*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</td>*/}
            <td>
                <div className="customer-details-field">
                    {(pointOfInterest.place_id) ? (<a target="_blank" href={URI_GOOGLE_MAPS_PLACE_ID + pointOfInterest.place_id}>{pointOfInterest.place_id}</a>) : ('-')}
                </div>
            </td>
            <td>
                <div className="customer-details-field">
                    {(pointOfInterest.status) ?? '-'}
                </div>
            </td>
            <td>
                <div className="customer-details-field">
                    {(pointOfInterest.relation_type) ?? '-'}
                </div>
            </td>
            {/*<td>*/}
            {/*    <div className="customer-details-field">*/}
            {/*        {(pointOfInterest.is_matched) ? dictionary.Poi_Matched : dictionary.Poi_Not_Matched}*/}
            {/*    </div>*/}
            {/*</td>*/}
            <td>
                <div className="customer-details-field">
                    {(pointOfInterest.gttd_relation_type) ?? '-'}
                </div>
            </td>
        </tr>
    )
            
}

ExperiencePoiItem.propTypes = {
  pointOfInterest: PropTypes.object,
  onItemCLicked: PropTypes.func
};

export default ExperiencePoiItem;